import { createContext } from "react";

import { DeviatingOpeningHours } from "types/DeviatingOpeningHours";

export const DeviatingOpeningHoursContext = createContext<DeviatingOpeningHours[]>(undefined);
